import { connect } from 'react-redux';
import { AppState } from '../../../redux/modules/store';
import Sorry from '../../../component/templates/Sorry';


const mapStateToProps = (appState: AppState) => {

  return {
    sorryMessage: appState.sorryMessage,
  };
};

export default connect(mapStateToProps)(Sorry);
